<template> 
  <div class="ability">
    <div class="banner">
      <img :src="$store.state.isMB?'static/mbimages/ability/核心能力.jpg':'static/images/ability/核心能力.jpg'" alt="">
      <div class="textNtitle">
        <div class="banner_title">核心服务能力</div>
        <div class="banner_text">面向云计算环境，提供统一应用开发工具、标准化开发流程，助力客户优化研发交付效率。
          <br>为构建业务中台、数据中台提供技术能力和产品能力。
          <br class="mbchangeLine">汽车后市场数据服务，覆盖多品类主流车型与零配件，具备完善的汽车行业数据库服务能力。
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="info_title">
        <span>快速功能开发，统一平台框架</span>
      </div>
      <div class="advan">
        <div class="detail" v-for="adv in advList" :key="adv.title">
          <img :src="adv.url" alt="">
          <div class="title">{{adv.title}}</div>
          <div class="text">{{adv.text}}</div>
        </div>
      </div>
    </div>
    <div class="bizstage">
      <div class="info_title">
        <span>业务中台</span>
      </div>
      <span class="explain">中台业务支撑服务包含了一系列的规范、工具、框架、组件和标准化落地经验，DSSP 在企业云服务领域深耕多年，业务中台板块积累了丰富的落地实践与技术沉淀，在PaaS当中，业务模组是让所有的伙伴能够一起实现业务能力并且不断优化能力，打造适配行业需求、具备差异化优势的业务落地模式。</span>
      <img :src="$store.state.isMB?'static/mbimages/ability/b1.jpg':'static/images/ability/业务中台.jpg'" alt="">
    </div>
    <div style="background:#f5f5f5;">
      <div class="datastage">
        <div class="info_title">
            <span>数据中台</span>
        </div>
        <span class="explain">数据中台为DSSP数字化运营和风险控制体系提供基础的技术支撑能力，是实现云原生架构的核心部分。数据中台依托于企业数据湖技术，构建了完整的跨行业多领域数据资产体系，同时实现对企业内部的数据驱动与外部客户的数据服务，并通过对数据的实时处理、挖掘和训练，依托数据实时处理、挖掘训练能力，赋能企业完成从 BI 数据分析到 AI 智能化应用的升级。</span>
        <img :src="$store.state.isMB?'static/mbimages/ability/b2.png':'static/images/ability/数据中台.png'" alt="">
        </div>
    </div>
    <div class="dataproducts">
      <div class="info_title">
        <span>汽车数据产品</span>
      </div>
      <img :src="$store.state.isMB?'static/mbimages/ability/data_bg.jpg':'static/images/ability/数据产品.jpg'" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      advList: [
        { title: '快速应对变化', url: 'static/images/ability/icon1.png', text:'丰富的能力及标准规范、标准化落地经验、研发协作和运营体系支撑业务快速调整和创新' },
        { title: '增强的用户体验', url: 'static/images/ability/icon2.png', text:'技术、能力、规范以及数据的融合，统一技术、数据与规范标准，保障产品全生命周期体验一致性' },
        { title: '减少低水平重复', url: 'static/images/ability/icon3.png', text:'通过能力沉淀和运营，依托标准化能力沉淀，减少重复开发工作，助力客户优化投入产出结构。培养并保留优秀人才供持续生产' },
        { title: '构建竞争优势', url: 'static/images/ability/icon4.png', text:'在业务发展过程中实现核心能力的数字化、融合化、生态化' }
      ]
    }
  },
  mounted () {
    window.scroll(0,0)
  }
}
</script>
<style lang="scss">
.ability{
  .banner{
    .textNtitle{
      @media screen and (max-width: 767px) {
        top: 20%;
      }
    }
    .banner_text{
      font-size: 18px;
      line-height: 30px;
      @media screen and (max-width: 767px) {
        font-size: 14px;
        line-height: 22px;
        margin-top: 3%;
      }
      @media screen and (max-width: 329px) {
        font-size: 12px;
      }
    }
  }
  .advantage{
    background: #f5f5f5;
    padding-top: 80px;
    height: 520px;
    @media screen and (max-width: 767px) {
      height: fit-content;
      padding-top: 50px;
    }
    .info_title{
      border: none;
      width: 414px;
      margin-bottom: 84px;
      @media screen and (max-width: 767px) {
        width: 90%;
        margin-bottom: 62px;
      }
      @media screen and (max-width: 340px) {
        font-size: 22px;
      }
    }
    .advan{
      width: 1200px;
      margin: auto;
      display: flex;
      justify-content: space-between;
      @media screen and (max-width: 767px) {
        flex-wrap: wrap;
        width: 100%;
        padding: 0 4%;
      }
      .detail{
        width: 192px;
        @media screen and (max-width: 767px) {
          width: 45%;
          margin-bottom: 17.68vw;
        }
        img{
          margin: auto;
          display: block;
          @media screen and (max-width: 767px) {
            height: 50px;
          }
        }
        .title{
          font-size: 24px;
          width: fit-content;
          margin: 27px auto 17px;
          @media screen and (max-width: 767px) {
            font-size: 22px;
            margin: 15px auto 12px;
          }
          @media screen and (max-width: 371px) {
            font-size: 20px;
          }
          @media screen and (max-width: 340px) {
            font-size: 18px;
          }
        }
        .text{
          color: #666;
          @media screen and (max-width: 767px) {
            font-size: 14px;
            padding-left: 5%;
          }
          @media screen and (max-width: 340px) {
            font-size: 12px;
          }
        }
      }
    }
  }
  .bizstage,.datastage,.dataproducts{
    width: 1200px;
    height: 685px;
    margin: auto;
    padding-top: 75px;
    @media screen and (max-width: 767px) {
      width: 100%;
      height: fit-content;
      padding: 50px 4% 50px;
    }
    .info_title{
      margin: 0 0 40px;
      width: 162px;
      border-right: none;
      @media screen and (max-width: 767px) {
        width: 125px;
        margin-bottom: 25px;
      }
    }
    .explain{
      line-height: 32px;
    }
    img{
      display: block;
      margin: 84px auto 0;
      @media screen and (max-width: 767px) {
        width: 100%;
        margin-top: 30px;
      }
    }
  }
  .datastage{
    height: 840px;
    @media screen and (max-width: 767px) {
      height: fit-content;
    }
    img{
      margin-top: 42px;
      @media screen and (max-width: 767px) {
        margin-top: 25px;
      }
    }
  }
  .dataproducts{
    height: 734px;
    @media screen and (max-width: 767px) {
      height: fit-content;
    }
    .info_title{
      width: 219px;
      @media screen and (max-width: 767px) {
        width: 170px;
      }
    }
    img{
      margin-top: 73px;
      @media screen and (max-width: 767px) {
        margin-top: 30px;
      }
    }
  }
}  
</style>


// WEBPACK FOOTER //
// src/components/comPages/ability.vue